import { jsx as _jsx } from "react/jsx-runtime";
import { useToastRegion } from '@react-aria/toast';
import { ToastQueue, useToastQueue } from '@react-stately/toast';
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { Toast } from './Toast.js';
function ToastRegion({ state, ...props }) {
    const ref = useRef(null);
    const { regionProps } = useToastRegion(props, state, ref);
    return (_jsx("div", { ...regionProps, ref: ref, className: "ppl-ToastRegion fixed bottom-0 left-1/2 mb-4 flex -translate-x-1/2 transform flex-col items-center", children: state.visibleToasts.map((toast) => (_jsx(Toast, { toast: toast, state: state }, toast.key))) }));
}
export const toastQueue = new ToastQueue({
    maxVisibleToasts: 5,
    hasExitAnimation: true,
});
export function GlobalToastRegion(props) {
    const state = useToastQueue(toastQueue);
    return state.visibleToasts.length > 0 ? createPortal(_jsx(ToastRegion, { ...props, state: state }), document.body) : null;
}
//# sourceMappingURL=GlobalToastRegion.js.map